<script lang="ts">
import CompanyEditor from "@/Components/CompanyEditor.vue";
import MainPage from "@/Components/MainPage.vue";
import Authenticated from "@/Layouts/Authenticated.vue";
import { EconomicSectors, QualificationsGroups } from "@/Types";
import { Policies } from "@/Types/acp";
import { Company } from "@/Types/company";
import axios from "axios";
import { defineComponent, PropType } from "vue";

export default defineComponent({
    name: "CreateCompanyVue",
    components: {
        MainPage,
        CompanyEditor,
    },
    layout: Authenticated,
    props: {
        qualificationGroups: {
            type: Object as PropType<QualificationsGroups>,
            required: true,
        },
        economicSectors: {
            type: Object as PropType<EconomicSectors>,
            required: true,
        },

        company: {
            type: Object as PropType<Company>,
            default: null,
        },
        policies: {
            type: Object as PropType<Policies>,
            default: null,
        },
        imageSize: {
            type: Number, // in MB
            required: true,
        },
        copy: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        submit(data: Company, clbk: (error?: unknown) => void, preserveState: boolean): void {
            axios
                .post(route("companies.store"), data)
                .then(() => {
                    if (clbk) clbk();
                    if (!preserveState) this.$inertia.visit(route("companies.index"), { preserveState: false });
                })
                .catch((error) => {
                    if (clbk) clbk(error);
                });
        },
    },
});
</script>

<template>
    <MainPage :title="$trans('acp.company_create')" :gap="true">
        <CompanyEditor
            :economic-sectors="economicSectors"
            :policies="policies"
            :company="company"
            :qualification-groups="qualificationGroups"
            :image-size="imageSize"
            :emit-actions="true"
            :show-active-checkbox="false"
            :create="true"
            :copy="copy"
            @submit="submit" />
    </MainPage>
</template>
